import React, { lazy } from 'react';

const IPHomepage = lazy(() => import('../Ip/IpHomepage.page.jsx'));
const IPCheckout = lazy(() => import('../Ip/IPCheckout/IPCheckout.page.jsx'));
const DisplayCourse = lazy(
  () => import('../Ip/IPCheckout/IPDisplayCourse.page.jsx')
);

export const IPRoutes = [
  { path: '', element: <IPHomepage /> },
  { path: 'course/:courseName/:id', element: <DisplayCourse /> },
  { path: 'checkout/:courseId', element: <IPCheckout /> },
];
